// extracted by mini-css-extract-plugin
module.exports = {"tech":"tech-372Xv4oC"};